import { Badge, Input, Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@@/ui/primitives';

const TIMEZONE_OPTIONS = [
  'UTC',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'Asia/Tokyo',
  'Asia/Shanghai',
  'Asia/Kolkata',
  'Australia/Sydney'
];

export interface DateTimeValue {
  timeZone: string;
  date: string;
  time: string;
}

interface DateTimeInputProps {
  value: DateTimeValue;
  onChange: (value: DateTimeValue) => void;
  disabled?: boolean;
  label?: string;
}

export function DateTimeInput({ value, onChange, disabled = false, label }: DateTimeInputProps) {
  const handleChange = (key: keyof DateTimeValue, newValue: string) => {
    const updatedValue = { ...value, [key]: newValue };
    onChange(updatedValue);
  };

  return (
    <div className='flex flex-col gap-2'>
      <div className='flex items-center gap-2'>
        {label && <Label className='text-neutral-800 text-sm font-medium'>{label}</Label>}
        <Badge variant='outline' className='text-slate-800 border-slate-400 text-xs!'>
          Date Time
        </Badge>
      </div>
      <Select
        value={value.timeZone}
        onValueChange={(newValue) => handleChange('timeZone', newValue)}
        disabled={disabled}
      >
        <SelectTrigger className='text-sm! font-medium! w-full bg-white'>
          <SelectValue placeholder='Select timezone...' />
        </SelectTrigger>
        <SelectContent>
          {TIMEZONE_OPTIONS.map((timezone) => (
            <SelectItem key={timezone} value={timezone}>
              {timezone}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <div className='flex flex-row gap-2'>
        <Input
          type='date'
          value={value.date}
          onChange={(e) => handleChange('date', e.target.value)}
          placeholder='Select date...'
          className='text-sm! font-medium! bg-white'
          disabled={disabled}
        />
        <Input
          type='time'
          value={value.time}
          onChange={(e) => handleChange('time', e.target.value)}
          placeholder='Select time...'
          className='text-sm! font-medium! bg-white'
          disabled={disabled}
        />
      </div>
    </div>
  );
}
